import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { PaymentService } from 'src/app/services/payment.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-state-wise-expenditure',
    templateUrl: './state-wise-expenditure.component.html',
    styleUrls: ['./state-wise-expenditure.component.scss'],
    standalone: false
})
export class StateWiseExpenditureComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'branch.name', header: 'Branch Name' },
    { field: 'balance', header: 'Balance' },
    { field: 'action', header: 'Action' },
  ];

  branches: any;
  selectedState: any;
  amountbalance = '2.5cr';
  selectedDate: any;
  expenditure: any = [];
  denomination: any = [];
  selectedDenomination!: number;
  pageNo: number = 1;
  totalRecords: number = 10;
  displayBranch!: any;
  walletId: any;
  isBalanceAdded: boolean;
  enteredBalance: any;
  addBalanceForm: FormGroup;
  selectedBranchWallet: any;
  walletDetails: any;

  constructor(private router: Router,
    private storageService: StorageService,
    private exportExcelService: ExportExcelService,
    private userDashboardService: UserDashboardService,
    private cookieService: CookieService,
    private paymentService: PaymentService,
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {
    this.userDashboardService.getBranchList().subscribe((res: any) => {

      this.branches = res['content'];
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
      this.cdr.detectChanges();
    })
    this.denomination =
      [
        { label: 10, value: 10 },
        { label: 100, value: 100 },
        { label: 50, value: 50 },
        { label: 1000, value: 100 },
        { label: 20, value: 20 },
      ];

    this.activatedRouter.params.subscribe((params) => {
      this.walletId = params['id'];
    });

    this.addBalanceForm = this.formBuilder.group({
      amount: new FormControl(null, [Validators.required])
    });
  }

  ngOnInit(): void {
    this.getBranchWallet()
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  export() {
    this.exportExcelService.convertToExcel(this.expenditure, 'expenditure');
  }

  onPageChange(event: any) {
    
  }

  getBranchWallet() {
    this.paymentService.getBranchWallet(this.walletId).subscribe((resp) => {
      if (resp.status == 200) {
        this.expenditure = resp.content;
        this.walletDetails = resp.content[0].payment_account
        this.totalRecords = resp.pagination.total_records;
        this.cdr.detectChanges();
      }
    })
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) || event.keyCode == 45) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  addBalance() {
    if (this.enteredBalance === undefined || this.enteredBalance === '') {
      this.isBalanceAdded = false
      return
    } else {
      let params = {
        "state_wallet_id": this.walletId,
        "branch_wallet": [
          {
            "branch_id": this.selectedBranchWallet.branch.id,
            "amount": this.enteredBalance
          }
        ]
      }

     

      this.paymentService.addNewBranchWallet(params).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.modalService.dismissAll()
            this.messageService.add({ severity: 'success', summary: 'Balance added successfully!' });
            this.getBranchWallet()
            this.enteredBalance = ''
          }
        },
       (error : any) => {
         
          this.messageService.add({ severity: 'error', summary: error.error.message });
        });
    }

  }

  openAddBalance(content, data) {
    this.enteredBalance = ''
    this.selectedBranchWallet = data
    this.isBalanceAdded = true
    this.modalService
      .open(content, {
        size: "lg",
        ariaLabelledBy: "modal-basic-title",
      })
      .result.then(
        (result) => { },
        (reason) => { }
      );
  }
}
